<span nvTooltip *ngIf="categories.length === 1">
  <nv-pill-button text="{{ categories[0] }}" [isInverted]="true"></nv-pill-button>
</span>

<span nvTooltip *ngIf="categories.length > 1">
  <nv-pill-button text="{{ categories[0] }}" [isInverted]="true"></nv-pill-button>
  <nv-pill-button class="second-pill" text="+{{ categories.length - 1 }}" [isInverted]="true"></nv-pill-button>
</span>
